export interface CachedEntityMapState {
  schemaIdsInFilter: Array<{id: string; name: string}>;
  hiddenSchemaIds: Array<string>;
  filterExpanded: boolean;
  userExpandedEntityIds: Array<string>;
}

const MAX_CACHE_SIZE = 100;
const cache = new Map<string, CachedEntityMapState>();

export function saveEntityMapState(entityId: string, state: CachedEntityMapState): void {
  cache.delete(entityId);
  if (cache.size >= MAX_CACHE_SIZE) {
    const oldest = cache.keys().next().value!;
    cache.delete(oldest);
  }
  cache.set(entityId, state);
}

export function getEntityMapState(entityId: string): CachedEntityMapState | undefined {
  const state = cache.get(entityId);
  if (state != null) {
    cache.delete(entityId);
    cache.set(entityId, state);
  }
  return state;
}

export function clearEntityMapStateCache(): void {
  cache.clear();
}
